import env from './utils/env'

export const config = {
    SERVER_HOST: env.server_host,
    WS_HOST: env.ws_host,
    ONESIGNAL_APP_ID: env.onesignal_app_id,
    // LOCAL_HOST: "127.0.0.1:8080/home",
    RSP_CODE:{
        SUCCESS : 0,
        FAIL: 1,
        INVALID_LOGIN_DATA: 2,
        INVALID_PHONE: 3,
        NOT_FOUND: 4,
        INVALID_MERCHANT_DATA: 5,
        REFUND: 7
    },
    DEFAULT_LOGO: "https://stgupfilemep.zalopay.vn/public-static/home/logo/default"
};
